var map = {
	"./html": 460,
	"./html.js": 460,
	"./json": 470,
	"./json.js": 470,
	"./md": 471,
	"./md.js": 471,
	"./toml": 472,
	"./toml.js": 472,
	"./yaml": 474,
	"./yaml.js": 474
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 459;



//////////////////
// WEBPACK FOOTER
// ../wrappers ^\.\/.*$
// module id = 459
// module chunks = 0